<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog', false)" @keydown.esc="$emit('updateDialog', false)" max-width="900px" transition="dialog-bottom-transition">
      <template v-slot:activator="{ props }">
        <v-btn flat class="mb-3 btn-second" v-bind="props" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <v-row align="center" justify="center" class="mb-4 mt-4">
              <v-col md="10" class="elevation-1 pt-4 pb-4" style="background: #f5f5f5">
                <a-steps :current="step">
                  <a-step v-for="s in steps" :key="s.title" :title="s.title" />
                </a-steps>
              </v-col>
            </v-row>

            <div class="steps-content">
              <!--step 0 - Datos-->
              <v-row align="start" justify="center" v-if="step == 0" transition="fade-transition">
                <v-col md="10" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step0" v-model="validStep0">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0"><b>Datos de la Regla</b></p>
                    </div>
                    <p>Complete los datos del producto, almacén y umbrales de reposición</p>

                    <v-row>
                      <v-col cols="12" md="6">
                        <v-combobox
                          label="Almacén*"
                          v-model="item.almacen"
                          :items="almacenes"
                          item-title="name"
                          item-value="id"
                          clearable
                          :disabled="disabled"
                          :rules="[rules.required]"
                          hint="La regla solo puede tener ubicaciones de este almacén"
                          persistent-hint
                          @update:modelValue="onAlmacenChange"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row>                      
                      <v-col cols="12" md="6" v-if="!isClient()">
                        <v-combobox
                          label="Cliente"
                          v-model="item.client"
                          :items="clients"
                          item-title="name"
                          item-value="id"
                          clearable
                          :disabled="disabled"
                          hint="Elegí el cliente para poder elegir el producto"
                          persistent-hint
                          @update:modelValue="onClientChange"
                        ></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox
                          label="Producto*"
                          v-model="item.product"
                          :items="products"
                          item-title="label"
                          item-value="id"
                          clearable
                          :disabled="disabled || (!isClient() && item.client == null)"
                          :loading="loading_products"
                          :rules="[rules.required]"
                          @update:modelValue="onProductChange"
                        ></v-combobox>
                        <div v-if="loading_product" class="text-caption mt-1 text-medium-emphasis">
                          <v-progress-circular indeterminate size="12" width="2" class="mr-1"></v-progress-circular>
                          Cargando unidad de almacenamiento…
                        </div>
                        <div v-else-if="product_storage_unit" class="text-caption mt-1 text-medium-emphasis">
                          Unidad de almacenamiento: <b>{{ product_storage_unit.name }}</b>
                        </div>
                      </v-col>

                      
                      <v-col cols="12" md="6">
                        <v-text-field
                          label="Stock mínimo*"
                          v-model="item.stock_min"
                          :disabled="disabled"
                          type="number"
                          min="0"
                          :rules="[rules.required]"
                          hint="Debajo de esta cantidad se genera la reposición"
                          persistent-hint
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field
                          label="Stock máximo*"
                          v-model="item.stock_max"
                          :disabled="disabled"
                          type="number"
                          min="1"
                          :rules="[rules.required]"
                          hint="Hasta esta cantidad se repone"
                          persistent-hint
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" v-if="max_menor_a_min">
                        <v-alert type="warning" density="compact" variant="tonal">El stock máximo debe ser mayor al stock mínimo.</v-alert>
                      </v-col>

                      <v-col cols="12">
                        <v-switch v-model="item.activo" label="Activa" color="green" :disabled="disabled"></v-switch>
                      </v-col>
                    </v-row>
                  </v-form>
                  <v-btn class="float-right btn-second" v-if="step < steps.length - 1" @click="next">Siguiente</v-btn>
                </v-col>
              </v-row>

              <!--step 1 - Ubicaciones-->
              <v-row align="start" justify="center" v-if="step == 1" transition="fade-transition">
                <v-col md="10" class="mt-4 pr-0 pl-0">
                  <div class="px-2 py-1 mb-3 bg-subtitle-section">
                    <p class="text-subtitle-1 mb-0"><b>Ubicaciones de Picking</b></p>
                  </div>
                  <p>Asigne las ubicaciones fijas de picking donde aplica la reposición</p>

                  <v-row align="center">
                    <v-col cols="12" md="4" v-if="!disabled">
                      <v-btn size="small" color="blue-grey" prepend-icon="mdi-plus" class="pl-4 text-white" :disabled="item.almacen == null" @click="dialog_ubicacion = true">
                        <span>Agregar Ubicación</span>
                      </v-btn>
                    </v-col>

                    <v-col cols="12" md="3" class="d-flex justify-center">
                      <v-chip size="small" variant="tonal" color="primary">
                        {{ item.locations.length }} ubicación(es)
                      </v-chip>
                    </v-col>

                    <v-col cols="12" md="5" v-if="item.locations.length > 0">
                      <v-text-field
                        v-model="locations_search"
                        density="compact"
                        label="Buscar en ubicaciones cargadas"
                        prepend-inner-icon="mdi-magnify"
                        clearable
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col md="12">
                      <v-alert v-if="item.almacen == null" type="warning" density="compact" variant="tonal" class="mb-2">
                        Elegí primero el almacén de la regla para poder agregar ubicaciones.
                      </v-alert>

                      <v-alert v-else-if="item.locations.length == 0" type="info" density="compact" variant="tonal" class="mb-2">
                        Agregá al menos una ubicación de picking para esta regla.
                      </v-alert>

                      <v-alert v-else-if="filtered_locations.length == 0" type="info" density="compact" variant="tonal" class="mb-2">
                        Ninguna ubicación coincide con la búsqueda.
                      </v-alert>

                      <v-data-table
                        v-else
                        :headers="location_headers"
                        :items="filtered_locations"
                        :items-per-page="10"
                        :items-per-page-options="[5, 10, 25, 50]"
                        density="compact"
                        items-per-page-text="Filas por página"
                      >
                        <template v-slot:item="{ item }">
                          <tr>
                            <td>{{ item.ubicacion.code }}</td>
                            <td>{{ item.ubicacion.zona && item.ubicacion.zona.almacen ? item.ubicacion.zona.almacen.code : "-" }}</td>
                            <td>{{ item.ubicacion.zona ? item.ubicacion.zona.name : "-" }}</td>
                            <td>{{ item.ubicacion.tipo_ubicacion ? item.ubicacion.tipo_ubicacion.name : "-" }}</td>
                            <td class="text-center" v-if="!disabled">
                              <v-icon small color="red" size="small" @click="removeLocation(item)">mdi-delete</v-icon>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>

                  <v-btn v-if="step > 0" @click="prev" class="mt-5" color="blue-grey">Atrás</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" :loading="loading" v-if="!disabled && step == 1">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <ModalUbicacion :dialog="dialog_ubicacion" :excluded_ids="selected_ubicacion_ids" :almacen="item.almacen" @close="dialog_ubicacion = false" @select="addLocation" />
  </v-layout>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import { productoService } from "@/libs/ws/productoService";
import { almacenService } from "@/libs/ws/almacenService";
import { clientService } from "@/libs/ws/clientService";
import UserTypes from "@/constants/user_type";
import ModalUbicacion from "./ReposicionRuleUbicacionModal.vue";

export default {
  components: { ModalUbicacion },
  mixins: [ValidMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      dialog_ubicacion: false,
      locations_search: "",
      validStep0: false,
      loading_product: false,
      loading_products: false,
      product_storage_unit: null,

      // Steps configuration
      step: 0,
      steps: [
        {
          title: "Datos",
          content: "Producto, almacén y umbrales de reposición",
        },
        {
          title: "Ubicaciones",
          content: "Ubicaciones fijas de picking donde aplica la regla",
        },
      ],

      products: [],
      almacenes: [],
      clients: [],
      item: {
        id: "",
        client: null, //Solo UI: no se persiste, deriva de product.client en el backend
        product: null,
        almacen: null,
        stock_min: null,
        stock_max: null,
        activo: true,
        locations: [],
      },
      defaultItem: null,
    };
  },
  computed: {
    max_menor_a_min() {
      if (this.item.stock_min === null || this.item.stock_max === null) return false;
      if (this.item.stock_min === "" || this.item.stock_max === "") return false;
      return parseInt(this.item.stock_max) <= parseInt(this.item.stock_min);
    },
    selected_ubicacion_ids() {
      return this.item.locations.map((l) => l.ubicacion.id);
    },
    filtered_locations() {
      const q = (this.locations_search || "").trim().toLowerCase();
      if (q === "") return this.item.locations;

      return this.item.locations.filter((l) => {
        const u = l.ubicacion;
        if (u == null) return false;
        const campos = [
          u.code,
          u.zona && u.zona.almacen ? u.zona.almacen.code : null,
          u.zona ? u.zona.name : null,
          u.tipo_ubicacion ? u.tipo_ubicacion.name : null,
        ];
        return campos.some((v) => v != null && String(v).toLowerCase().includes(q));
      });
    },
    location_headers() {
      const cols = [
        { title: "Código", key: "ubicacion.code", sortable: false, align: "start" },
        { title: "Almacén", key: "almacen", sortable: false, align: "start" },
        { title: "Zona", key: "zona", sortable: false, align: "start" },
        { title: "Tipo", key: "tipo", sortable: false, align: "start" },
      ];
      if (!this.disabled) cols.push({ title: "Acción", key: "actions", sortable: false, align: "center" });
      return cols;
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.disabled = this.formBtn == "";
        this.step = 0;
        this.locations_search = "";
        this.product_storage_unit = null;

        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
        if (this.$refs.form_step0) {
          this.$refs.form_step0.resetValidation();
        }

        if (this.editItem != null && this.editItem.id > 0) {
          this.item = JSON.parse(JSON.stringify(this.editItem));
          if (this.item.locations == null) this.item.locations = [];

          //El cliente no se persiste en la regla: se precarga desde lo que trae el backend
          //(client derivado de product.client en el jsonSerialize) para que el combo de
          //Producto tenga con que resolver el valor ya seleccionado.
          this.item.client = this.editItem.client || (this.editItem.product ? this.editItem.product.client : null);
          if (this.item.client != null && this.item.client.id > 0) {
            this.loadProducts(this.item.client.id);
          } else if (this.isClient()) {
            this.loadProducts();
          }
        } else {
          if (this.defaultItem != null) this.item = JSON.parse(JSON.stringify(this.defaultItem));
          this.products = [];
          if (this.isClient()) this.loadProducts();
        }

        //Editando: si ya hay producto, traigo su unidad de almacenamiento para mostrarla
        if (this.item.product != null && this.item.product.id > 0) {
          this.loadProductStorageUnit(this.item.product.id);
        }
      }
    },
  },
  mounted() {
    this.loadAlmacenes();
    if (!this.isClient()) this.loadClients();
    else this.loadProducts(); //Usuario cliente: no hay combo de cliente, el backend fuerza el suyo

    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    isClient() {
      return localStorage.getItem("user_type") == UserTypes.CLIENT;
    },
    loadClients() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("clientService.filter error", e);
        });
    },
    loadProducts(client_id = null) {
      //list_minify: solo id/name/sku/label — la unidad de almacenamiento se pide aparte
      //con productoService.get() cuando el usuario selecciona un producto puntual.
      this.loading_products = true;
      const params = {};
      if (client_id) params.client = { id: client_id };
      productoService
        .list_minify(params)
        .then((response) => {
          this.products = response.result.list;
        })
        .catch(() => {
          this.products = [];
        })
        .finally(() => {
          this.loading_products = false;
        });
    },
    onClientChange(client) {
      //Cambiar (o limpiar) el cliente invalida el producto elegido: pertenece a otro cliente.
      this.item.product = null;
      this.product_storage_unit = null;
      this.products = [];
      if (client != null && client.id) this.loadProducts(client.id);
    },
    onProductChange(product) {
      //Cuando cambia el producto seleccionado, refresco la unidad de almacenamiento que
      //se muestra debajo del combobox. La info no vive en list_minify a proposito.
      if (product == null || product.id == null) {
        this.product_storage_unit = null;
        return;
      }
      this.loadProductStorageUnit(product.id);
    },
    loadProductStorageUnit(product_id) {
      this.loading_product = true;
      this.product_storage_unit = null;
      productoService
        .get({ id: product_id })
        .then((response) => {
          if (response.status && response.result) {
            this.product_storage_unit = response.result.storage_unit || null;
          }
        })
        .catch(() => {
          //Silencioso: si falla, el ABM sigue funcionando; solo pierde el hint
        })
        .finally(() => {
          this.loading_product = false;
        });
    },
    loadAlmacenes() {
      almacenService.filter({}).then((response) => {
        this.almacenes = response.result.list;
        //Si hay un unico almacen disponible, se preselecciona (no pisa una seleccion ya hecha,
        //p.ej. al editar una regla existente)
        if (this.almacenes.length === 1) {
          const unico = this.almacenes[0];
          if (this.defaultItem != null && this.defaultItem.almacen == null) this.defaultItem.almacen = unico;
          if (this.item.almacen == null) this.item.almacen = unico;
        }
      });
    },
    // Métodos de navegación entre steps
    async next() {
      // Validar datos obligatorios del step actual antes de avanzar
      if (this.step === 0) {
        if (this.$refs.form_step0) {
          const { valid } = await this.$refs.form_step0.validate();
          if (!valid) {
            this.toast.error("Por favor complete todos los campos obligatorios");
            return;
          }
        }
        //max > min no lo cubre el validator de Vuetify: es cruzado entre dos campos
        if (this.max_menor_a_min) {
          this.toast.error("El stock máximo debe ser mayor al stock mínimo.");
          return;
        }
      }

      if (this.step < this.steps.length - 1) {
        this.step++;
      }
    },

    prev() {
      if (this.step > 0) {
        this.step--;
      }
    },
    onAlmacenChange(nuevo) {
      //Cambiar de almacen invalida las ubicaciones cargadas: pertenecen a otro deposito.
      if (this.item.locations.length > 0) {
        const nuevo_id = nuevo != null ? nuevo.id : null;
        const mismas = this.item.locations.every((l) => {
          const almacen_ubi = l.ubicacion && l.ubicacion.zona && l.ubicacion.zona.almacen ? l.ubicacion.zona.almacen.id : null;
          return almacen_ubi != null && almacen_ubi === nuevo_id;
        });
        if (!mismas) {
          this.item.locations = [];
          this.toast.info("Se limpiaron las ubicaciones porque pertenecen a otro almacén.");
        }
      }
    },
    addLocation(ubicaciones) {
      //ModalUbicacion emite un array (seleccion multiple con checkboxes).
      //Fallback por si llega un objeto suelto (ej. hot-reload con codigo viejo cargado)
      const arr = Array.isArray(ubicaciones) ? ubicaciones : [ubicaciones];
      arr.forEach((ubicacion) => {
        if (this.selected_ubicacion_ids.includes(ubicacion.id)) return;
        this.item.locations.push({ id: null, ubicacion: ubicacion });
      });
      this.dialog_ubicacion = false;
    },
    removeLocation(location) {
      //Recibo el objeto (no el indice) porque puede venir de filtered_locations,
      //cuyos indices no coinciden con item.locations cuando hay busqueda activa.
      const idx = this.item.locations.indexOf(location);
      if (idx >= 0) this.item.locations.splice(idx, 1);
    },
    async createItem() {
      if (this.loading) return;

      if (this.max_menor_a_min) {
        this.toast.error("El stock máximo debe ser mayor al stock mínimo.");
        return;
      }

      if (this.item.almacen == null) {
        this.toast.error("La regla debe tener un almacén.");
        return;
      }

      if (this.item.locations.length == 0) {
        this.toast.error("La regla debe tener al menos una ubicación de picking.");
        return;
      }

      //El outer <v-form> no trackea los campos que viven dentro del sub-form del paso 0,
      //asi que this.valid queda false. Re-validamos el sub-form directamente.
      if (this.$refs.form_step0) {
        const { valid } = await this.$refs.form_step0.validate();
        if (!valid) {
          this.step = 0;
          this.toast.error("Por favor complete todos los campos obligatorios");
          return;
        }
      }

      this.loading = true;

      var data = {
        id: this.item.id,
        product: { id: this.item.product.id },
        almacen: { id: this.item.almacen.id },
        stock_min: parseInt(this.item.stock_min),
        stock_max: parseInt(this.item.stock_max),
        activo: this.item.activo,
        //editCollection del backend espera <coleccion>_arr
        locations_arr: this.item.locations.map((l) => ({
          id: l.id,
          ubicacion: { id: l.ubicacion.id },
        })),
      };

      if (this.item.id > 0) {
        this.service
          .update(data)
          .then((response) => {
            if (response.status) {
              this.toast.success("La " + this.modal_title + " se modificó correctamente.");
              this.$emit("updateDialog", false);
              this.$emit("loadList");
            } else {
              if (Object.prototype.hasOwnProperty.call(response, "message")) {
                this.toast.error(response.message);
              } else {
                this.toast.error(response.msg);
              }
            }
          })
          .catch((response) => {
            this.toast.error(response.msg);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.service
          .create(data)
          .then((response) => {
            if (response.status) {
              this.toast.success("La " + this.modal_title + " se creó correctamente");
              this.$emit("updateDialog", false);
              this.$emit("loadList");
            } else {
              if (Object.prototype.hasOwnProperty.call(response, "message")) {
                this.toast.error(response.message);
              } else {
                this.toast.error(response.msg);
              }
            }
          })
          .catch((e) => {
            this.toast.error(e);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
